import { permissionOptions } from "../assets/constants/default_options";
import { ADMIN_USERNAME } from "../config/constants";
import { IBasePermission, IPermission } from "../models/role.model";
import { IUser } from "../models/user.model";
import _ from 'lodash';

export const convertListStringToPermission = (perms: string[]) => {
    return perms?.length > 0 ? perms.map((item: | string) => {
        const [action, resource] = item?.split('::')
        return { action, resource }
    }) : []
}

export const convertListPermissionToString = (perms: IPermission[] | undefined) => {
    return perms?.map((item: IPermission) => {
        return `${item.action}::${item.resource}`
    })
}

export const convertListGroupPermissionToString = (perms: IPermission[] | undefined, group: string) => {
    return perms?.map((perm: IPermission) => permissionOptions
        .map(item => item.group === group && item.value === `${perm.action}::${perm.resource}` && item.value)
        .filter(item => item)[0],
    ).filter(item => item)
}

export const convertListBasePermissionToOption = (perms: IBasePermission[]) => {
    return perms.map((item: IBasePermission) => ({
        label: item.description,
        value: `${item.action}::${item.resource}`,
        group: item.group,
        name: item.group_name,
    }))
}

const isAdmin = ADMIN_USERNAME
const canSeePackageTab = 'GET::/api/otek-dashboard/packages/see-package-tab'
const canUpdatePhoneSim = 'PUT::/api/otek-dashboard/transaction-connection/update-phone-sim'
const canSelectDateConnect = 'GET::/api/otek-dashboard/transaction-connection/select-date-connect'

// Companies
const canGetListCompanies = 'GET::/api/otek-dashboard/companies'
const canAddCompany = 'POST::/api/otek-dashboard/companies'
const canUpdateCompany = 'PATCH::/api/otek-dashboard/companies'
const canDeleteCompany = 'DELETE::/api/otek-dashboard/companies'
const canGetListMetadata = 'GET::/api/otek-dashboard/companies/get-list-metadata'
const canAddListMetadata = 'POST::/api/otek-dashboard/companies/add-list-metadata'
const canUpdateListMetadata = 'PUT::/api/otek-dashboard/companies/update-list-metadata'
const canGetListFeedbackHistory = 'GET::/api/otek-dashboard/companies/get-list-feedback-history'
const canAddListFeedbackHistory = 'POST::/api/otek-dashboard/companies/add-list-feedback-history'
const canUpdateListFeedbackHistory = 'PUT::/api/otek-dashboard/companies/update-list-feedback-history'
const canGetListCompanyNotifyConfig = 'GET::/api/otek-dashboard/companies/get-list-company-notify-config'
const canGetCompanyNotifyConfig = 'GET::/api/otek-dashboard/companies/get-company-notify-config'
const canAddCompanyNotifyConfig = 'POST::/api/otek-dashboard/companies/add-company-notify-config'
const canUpdateCompanyNotifyConfig = 'PUT::/api/otek-dashboard/companies/update-company-notify-config'

// Packages
const canGetListPackages = 'GET::/api/otek-dashboard/packages'
const canAddPackage = 'POST::/api/otek-dashboard/packages'
const canAddListPackages = 'POST::/api/otek-dashboard/packages/add-list-packages'
const canUpdatePackage = 'PATCH::/api/otek-dashboard/packages'
const canDeletePackage = 'DELETE::/api/otek-dashboard/packages'

// Partner Packages
const canGetListPartnerPackages = 'GET::/api/otek-dashboard/partner-packages'
const canAddPartnerPackage = 'POST::/api/otek-dashboard/partner-packages'
const canAddListPartnerPackages = 'POST::/api/otek-dashboard/partner-packages/add-list-partner-packages'
const canDeletePartnerPackage = 'DELETE::/api/otek-dashboard/partner-packages'
const canUpdatePartnerPackage = 'PATCH::/api/otek-dashboard/partner-packages'
const canGetListPackagesTkgDashboard = 'GET::/api/otek-dashboard/partner-packages/get-list-packages-tkg-dashboard'
const canGetListPackagesSponsor = 'GET::/api/otek-dashboard/partner-packages/get-list-packages-sponsor'
const canGetListPackagesConnection = 'GET::/api/otek-dashboard/partner-packages/get-list-packages-connection'

// Rule base
const canGetListPackageDiscount = 'GET::/api/otek-dashboard/rule-base/get-list-package-discount'
const canAddListPackageDiscount = 'POST::/api/otek-dashboard/rule-base/add-list-package-discount'
const canUpdateListPackageDiscount = 'PATCH::/api/otek-dashboard/rule-base/update-list-package-discount'
const canDeleteListPackageDiscount = 'DELETE::/api/otek-dashboard/rule-base/update-list-package-discount'
const canGetListConditionRule = 'GET::/api/otek-dashboard/rule-base/get-list-condition-rule'
const canAddListConditionRule = 'POST::/api/otek-dashboard/rule-base/add-list-condition-rule'
const canUpdateListConditionRule = 'PATCH::/api/otek-dashboard/rule-base/update-list-condition-rule'
const canDeleteListConditionRule = 'DELETE::/api/otek-dashboard/rule-base/update-list-condition-rule'

// Telegrams
const canGetListTelegrams = 'GET::/api/otek-dashboard/telegrams'
const canAddTelegram = 'POST::/api/otek-dashboard/telegrams'
const canUpdateTelegram = 'PATCH::/api/otek-dashboard/telegrams'
const canDeleteTelegram = 'DELETE::/api/otek-dashboard/telegrams'

// Transactions
const canGetListTransactions = 'GET::/api/otek-dashboard/transactions'
const canRenewTransaction = 'PATCH::/api/otek-dashboard/transactions'
const canAddTransaction = 'POST::/api/otek-dashboard/transactions'
const canConnectTransaction = 'POST::/api/otek-dashboard/transactions/connect'

// Users
const canGetListUsers = 'GET::/api/otek-dashboard/users'
const canAddUser = 'POST::/api/otek-dashboard/users'
const canUpdateUser = 'PATCH::/api/otek-dashboard/users'
const canDeleteUser = 'DELETE::/api/otek-dashboard/users'

// Roles
const canGetListBasePermissions = 'GET::/api/otek-dashboard/base-permissions'
const canReloadBasePermissions = 'POST::/api/otek-dashboard/base-permissions/reload-policy'
const canGetListRoles = 'GET::/api/otek-dashboard/roles'
const canAddRole = 'POST::/api/otek-dashboard/roles'
const canUpdateRole = 'PATCH::/api/otek-dashboard/roles'
const canDeleteRole = 'DELETE::/api/otek-dashboard/roles'

// Sim Passports
const canGetListSimPassports = 'GET::/api/otek-dashboard/sim-passports'
const canUpdateSimPassport = 'PATCH::/api/otek-dashboard/sim-passports'

// Mbh Topups
const canCheckBalanceTopup = 'GET::/api/otek-dashboard/mbh-topups/check-balance-topup'
const canGetListOrderTopups = 'GET::/api/otek-dashboard/mbh-topups/get-list-order-topups'
const canGetListTransactionTopupsByOrderId = 'GET::/api/otek-dashboard/mbh-topups/get-list-transaction-topups-by-order-id'
const canCheckTransactionTopupOnResource = 'GET::/api/otek-dashboard/mbh-topups/check-transaction-topup-on-resource'
const canCheckTransactionTopupOnAdapter = 'GET::/api/otek-dashboard/mbh-topups/check-transaction-topup-on-adapter'
const canUploadOrderTopupByExcel = 'POST::/api/otek-dashboard/mbh-topups/upload-order-topup-by-excel'
const canTopupByPhone = 'POST::/api/otek-dashboard/mbh-topups/topup-by-phone'
const canTopupByOrderId = 'POST::/api/otek-dashboard/mbh-topups/topup-by-order-id'
const canUpdateStatusTransactionTopup = 'PATCH::/api/otek-dashboard/mbh-topups/update-status-transaction-topup'
const canUpdateLockOrderTopup = 'PATCH::/api/otek-dashboard/mbh-topups/update-lock-order-topup'

// Report
const canCreateReportOrderTopups = 'POST::/api/otek-dashboard/report/download-order-topups'
const canCreateReportTransactionConnection = 'POST::/api/otek-dashboard/report/download-transaction-connection'
const canCreateReportTransactionConnectionAll = 'POST::/api/otek-dashboard/report/download-transaction-connection-all'
const canGetReportStatus = 'GET::/api/otek-dashboard/report/report-status'
const canGetReportDownload = 'GET::/api/otek-dashboard/report/report-download'

// Mbh Tkg Dashboard
const canGetDynamicPartnerOffer = 'GET::/api/otek-dashboard/mbh-tkg-dashboard/get-dynamic-partner-offer'
const canGetListOrderTkgDashboard = 'GET::/api/otek-dashboard/mbh-tkg-dashboard/get-list-order-tkg-dashboard'
const canGetListTransactionTkgDashboardByOrderId = 'GET::/api/otek-dashboard/mbh-tkg-dashboard/get-list-transaction-tkg-dashboard-by-order-id'
const canCheckTransactionTkgOnResource = 'GET::/api/otek-dashboard/mbh-tkg-dashboard/check-transaction-tkg-dashboard-on-resource'
const canCheckTransactionTkgOnAdapter = 'GET::/api/otek-dashboard/mbh-tkg-dashboard/check-transaction-tkg-dashboard-on-adapter'
const canUploadOrderTkgByExcel = 'POST::/api/otek-dashboard/mbh-tkg-dashboard/upload-order-tkg-dashboard-by-excel'
const canTkgByPhone = 'POST::/api/otek-dashboard/mbh-tkg-dashboard/tkg-dashboard-by-phone'
const canTkgByOrderId = 'POST::/api/otek-dashboard/mbh-tkg-dashboard/tkg-dashboard-by-order-id'
const canUpdateStatusTransactionTkgDashboard = 'PATCH::/api/otek-dashboard/mbh-tkg-dashboard/update-status-transaction-tkg-dashboard'
const canUpdateLockOrderTkgDashboard = 'PATCH::/api/otek-dashboard/mbh-tkg-dashboard/update-lock-order-tkg-dashboard'

// Data Sponsor
const canGetDynamicPartnerOfferDataSponsor = 'GET::/api/otek-dashboard/data-sponsor/get-dynamic-partner-offer-data-sponsor'
const canGetListOrderDataSponsor = 'GET::/api/otek-dashboard/data-sponsor/get-list-order-data-sponsor'
const canGetListTransactionDataSponsorByOrderId = 'GET::/api/otek-dashboard/data-sponsor/get-list-transaction-data-sponsor-by-order-id'
const canCheckTransactionDataSponsorOnResource = 'GET::/api/otek-dashboard/data-sponsor/check-transaction-data-sponsor-on-resource'
const canCheckTransactionDataSponsorOnAdapter = 'GET::/api/otek-dashboard/data-sponsor/check-transaction-data-sponsor-on-adapter'
const canUploadOrderDataSponsorByExcel = 'POST::/api/otek-dashboard/data-sponsor/upload-order-data-sponsor-by-excel'
const canDataSponsorByPhone = 'POST::/api/otek-dashboard/data-sponsor/data-sponsor-by-phone'
const canDataSponsorByOrderId = 'POST::/api/otek-dashboard/data-sponsor/data-sponsor-by-order-id'
const canCheckWalletBalancePostpaid = 'GET::/api/otek-dashboard/data-sponsor/check-wallet-balance-postpaid'
const canUpdateStatusTransactionDataSponsor = 'PATCH::/api/otek-dashboard/data-sponsor/update-status-transaction-data-sponsor'
const canUpdateLockOrderDataSponsor = 'PATCH::/api/otek-dashboard/data-sponsor/update-lock-order-data-sponsor'

// User Partner
const canGetListUserPartners = 'GET::/api/otek-dashboard/user-partners/get-list-user-partners'
const canAddUserPartner = 'POST::/api/otek-dashboard/user-partners/add-user-partner'
const canUpdateUserPartner = 'PATCH::/api/otek-dashboard/user-partners/update-user-partner'
const canDeleteUserPartner = 'DELETE::/api/otek-dashboard/user-partners/delete-user-partner'

// Transaction Connection
const canGetListTransactionConnection = 'GET::/api/otek-dashboard/transaction-connection/get-list-transaction-connection'
const canAddListTransactionConnection = 'POST::/api/otek-dashboard/transaction-connection/add-list-transaction-connection'
const canUpdateListTransactionConnection = 'PUT::/api/otek-dashboard/transaction-connection/update-list-transaction-connection'
const canAddTransactionConnectionBySyntax = 'POST::/api/otek-dashboard/transaction-connection/add-transaction-connection'
const canGetListTransactionConnectionExpire = 'GET::/api/otek-dashboard/transaction-connection/get-list-transaction-connection-expire'
const canGetListTransactionConnectionView = 'GET::/api/otek-dashboard/transaction-connection/get-list-transaction-connection-view'
const canUpdateListSimTransactionConnection = 'PUT::/api/otek-dashboard/transaction-connection/update-list-sim-transaction-connection'
const canUpdatePhoneNumberTransactionConnection = 'PUT::/api/otek-dashboard/transaction-connection/update-phone-number-transaction-connection'
const canUpdateDataPackTransactionConnection = 'PUT::/api/otek-dashboard/transaction-connection/update-data-pack-transaction-connection'
const canUpdateFailedTransactionConnection = 'PUT::/api/otek-dashboard/transaction-connection/update-failed-transaction-connection'

// Registration Request
const canGetListRegistrationRequests = 'GET::/api/otek-dashboard/registration-request/get-list-registration-requests'
const canAddListRegistrationRequests = 'POST::/api/otek-dashboard/registration-request/add-list-registration-requests'
const canUpdateListRegistrationRequests = 'PUT::/api/otek-dashboard/registration-request/update-list-registration-requests'
const canDeleteListRegistrationRequests = 'DELETE::/api/otek-dashboard/registration-request/delete-list-registration-requests'

// Order Transaction Connection
const canGetListOrderTransactionConnection = 'GET::/api/otek-dashboard/order-transaction-connection/get-list-order-transaction-connection'
const canGetOrderTransactionConnectionDetail = 'GET::/api/otek-dashboard/order-transaction-connection/get-order-transaction-connection-detail'
const canUploadOrderTransactionConnectionByExcel = 'POST::/api/otek-dashboard/order-transaction-connection/upload-order-transaction-connection-by-excel'
const canAddTransactionConnectionByOrderId = 'POST::/api/otek-dashboard/order-transaction-connection/add-transaction-connection-by-order-id'
const canUpdateOrderTransactionConnection = 'PUT::/api/otek-dashboard/order-transaction-connection/update-order-transaction-connection'

// Statistical Service
const canGetRevenueConnection = 'GET::/api/otek-dashboard/statistical-service/get-revenue-connection'
const canGetRevenueDateConnection = 'GET::/api/otek-dashboard/statistical-service/get-date-revenue-connection'
const canGetStatisticalTypeConnection = 'GET::/api/otek-dashboard/statistical-service/get-statistical-type-connection'
const canGetStatisticalDateConnection = 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-connection'
const canGetStatisticalPackDurationConnection = 'GET::/api/otek-dashboard/statistical-service/get-statistical-pack-duration-connection'
const canGetStatisticalTypeExpiration = 'GET::/api/otek-dashboard/statistical-service/get-statistical-type-expiration'
const canGetStatisticalDateExpiration = 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-expiration'
const canGetStatisticalDateExtension = 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-extension'
const canRecalculateStatistics = 'PATCH::/api/otek-dashboard/statistical-service/recalculate-statistics'
const canGetStatisticalDateCalling = 'GET::/api/otek-dashboard/statistical-service/get-statistical-date-calling'
const canGetStatisticalTypeCalling = 'GET::/api/otek-dashboard/statistical-service/get-statistical-type-calling'
const canGetStatisticalTelesaleCalling = 'GET::/api/otek-dashboard/statistical-service/get-statistical-telesale-calling'

// Customer Resource
const canGetListCustomerResource = 'GET::/api/otek-dashboard/customer-resource/get-list-customer-resource'
const canAddListCustomerResource = 'POST::/api/otek-dashboard/customer-resource/add-list-customer-resource'
const canUpdateListCustomerResource = 'PUT::/api/otek-dashboard/customer-resource/update-list-customer-resource'

// Phone Agency
const canGetListPhoneAgencies = 'GET::/api/otek-dashboard/phone-agencies/get-list-phone-agencies'
const canAddListPhoneAgencies = 'POST::/api/otek-dashboard/phone-agencies/add-list-phone-agencies'
const canUpdateListPhoneAgencies = 'PUT::/api/otek-dashboard/phone-agencies/update-list-phone-agencies'

// Call Info
const canGetListCallInfo = 'GET::/api/otek-dashboard/call-info/get-list-call-info'
const canGetListCallInfoDetail = 'GET::/api/otek-dashboard/call-info/get-list-call-info-detail'
const canAddListCallTelesale = 'POST::/api/otek-dashboard/call-info/add-list-call-telesale'
const canAddLogFeedback = 'POST::/api/otek-dashboard/call-info/add-log-feedback'
const canUpdateListCallInfo = 'PUT::/api/otek-dashboard/call-info/update-list-call-info'

// Call Log
const canGetListCallLog = 'GET::/api/otek-dashboard/call-log/get-list-call-log'
const canAddListCallLog = 'POST::/api/otek-dashboard/call-log/add-list-call-log'
const canUpdateListCallLog = 'PUT::/api/otek-dashboard/call-log/update-list-call-log'

// Mhb Inventory
const canAddOrderInventory = 'POST::/api/otek-dashboard/mbh-inventory/add-order-inventory'
const canGetListOrderInventory = 'GET::/api/otek-dashboard/mbh-inventory/get-list-order-inventory'
const canUpdateOrderInventory = 'PUT::/api/otek-dashboard/mbh-inventory/update-order-inventory'
const canViewExportOrderPage = 'VIEW::/page/export-order'
const canGetListSimInventory = 'GET::/api/otek-dashboard/mbh-inventory/get-list-sim-inventory'
const canGetSimInventoryByOrderIds = 'POST::/api/otek-dashboard/mbh-inventory/get-sim-inventory-by-order-ids'
const canUpdateSimInventory = 'PUT::/api/otek-dashboard/mbh-inventory/update-sim-inventory'
const canAddOrderWarehouse = 'POST::/api/otek-dashboard/mbh-inventory/add-order-warehouse'
const canGetListOrderWarehouse = 'GET::/api/otek-dashboard/mbh-inventory/get-list-order-warehouse'
const canUpdateOrderWarehouse = 'PUT::/api/otek-dashboard/mbh-inventory/update-order-warehouse'

// Mbh Sales Inventory
const canAddSalesOrderInventory = 'POST::/api/otek-dashboard/mbh-sales-inventory/add-sales-order'
const canAddSalesOrderInfo = 'POST::/api/otek-dashboard/mbh-sales-inventory/add-sales-order-info'
const canGetListSalesOrderInventory = 'GET::/api/otek-dashboard/mbh-sales-inventory/get-list-sales-order'
const canUpdateSalesOrderInventory = 'PUT::/api/otek-dashboard/mbh-sales-inventory/update-sales-order'
const canViewSalesExportOrderPage = 'VIEW::/page/export-sales-order'

// Config
const canGetListVersions = 'GET::/api/otek-dashboard/config/get-list-versions'
const canAddListVersions = 'POST::/api/otek-dashboard/config/add-list-versions'
const canUpdateListVersions = 'PUT::/api/otek-dashboard/config/update-list-versions'
const canDeleteListVersions = 'DELETE::/api/otek-dashboard/config/delete-list-versions'
const canGetListBankAccounts = 'GET::/api/otek-dashboard/config/get-list-bank-accounts'
const canAddListBankAccounts = 'POST::/api/otek-dashboard/config/add-list-bank-accounts'
const canUpdateListBankAccounts = 'PUT::/api/otek-dashboard/config/update-list-bank-accounts'
const canGetListPartnerConfig = 'GET::/api/otek-dashboard/config/get-list-partner-config'
const canAddListPartnerConfig = 'POST::/api/otek-dashboard/config/add-list-partner-config'
const canUpdateListPartnerConfig = 'PUT::/api/otek-dashboard/config/update-list-partner-config'
const canGetListTopUpConfig = 'GET::/api/otek-dashboard/config/get-list-top-up-config'
const canAddListTopUpConfig = 'POST::/api/otek-dashboard/config/add-list-top-up-config'
const canUpdateListTopUpConfig = 'PUT::/api/otek-dashboard/config/update-list-top-up-config'
const canGetListTkgConfig = 'GET::/api/otek-dashboard/config/get-list-tkg-config'
const canAddListTkgConfig = 'POST::/api/otek-dashboard/config/add-list-tkg-config'
const canUpdateListTkgConfig = 'PUT::/api/otek-dashboard/config/update-list-tkg-config'
const canGetListDevices = 'GET::/api/otek-dashboard/config/get-list-devices'
const canAddListDevices = 'POST::/api/otek-dashboard/config/add-list-devices'
const canUpdateListDevices = 'PUT::/api/otek-dashboard/config/update-list-devices'
const canDeleteListDevices = 'DELETE::/api/otek-dashboard/config/delete-list-devices'
const canGetListTelesaleConfig = 'GET::/api/otek-dashboard/config/get-list-telesale-config'
const canAddListTelesaleConfig = 'POST::/api/otek-dashboard/config/add-list-telesale-config'
const canUpdateListTelesaleConfig = 'PUT::/api/otek-dashboard/config/update-list-telesale-config'
const canGetListInvoiceConfig = 'GET::/api/otek-dashboard/config/get-list-invoice-config'
const canAddListInvoiceConfig = 'POST::/api/otek-dashboard/config/add-list-invoice-config'
const canUpdateListInvoiceConfig = 'PUT::/api/otek-dashboard/config/update-list-invoice-config'
const canGetListSannConfig = 'GET::/api/otek-dashboard/config/get-list-sann-config'
const canAddListSannConfig = 'POST::/api/otek-dashboard/config/add-list-sann-config'
const canUpdateListSannConfig = 'PUT::/api/otek-dashboard/config/update-list-sann-config'

// Invoice
const canGetTypeInvoiceAdapter = 'GET::/api/otek-dashboard/invoice/get-type-invoice-adapter'
const canGetInvoiceAdapter = 'GET::/api/otek-dashboard/invoice/get-invoice-adapter'
const canGetListInvoiceAdapter = 'GET::/api/otek-dashboard/invoice/get-list-invoice-adapter'
const canGetPrintInvoiceAdapter = 'GET::/api/otek-dashboard/invoice/get-print-invoice-adapter'
const canGetListInvoices = 'GET::/api/otek-dashboard/invoice/get-list-invoices'
const canAddInvoice = 'POST::/api/otek-dashboard/invoice/add-invoice'
const canAddInvoiceByForm = 'POST::/api/otek-dashboard/invoice/add-invoice-by-form'
const canUpdateInvoice = 'PUT::/api/otek-dashboard/invoice/update-invoice'
const canDeleteInvoice = 'DELETE::/api/otek-dashboard/invoice/delete-invoice'
const canGetListInvoiceTemplates = 'GET::/api/otek-dashboard/invoice/get-list-invoice-templates'
const canAddListInvoiceTemplates = 'POST::/api/otek-dashboard/invoice/add-list-invoice-templates'
const canUpdateListInvoiceTemplates = 'PUT::/api/otek-dashboard/invoice/update-list-invoice-templates'
const canDeleteListInvoiceTemplates = 'DELETE::/api/otek-dashboard/invoice/delete-list-invoice-templates'
const canGetListInvoiceTemplateItems = 'GET::/api/otek-dashboard/invoice/get-list-invoice-template-items'
const canAddListInvoiceTemplateItems = 'POST::/api/otek-dashboard/invoice/add-list-invoice-template-items'
const canUpdateListInvoiceTemplateItems = 'PUT::/api/otek-dashboard/invoice/update-list-invoice-template-items'
const canDeleteListInvoiceTemplateItems = 'DELETE::/api/otek-dashboard/invoice/delete-list-invoice-template-items'
const canAddInvoiceAdapterByInvoiceId = 'POST::/api/otek-dashboard/invoice/add-invoice-adapter-by-invoice-id'

// Zalo Account
const canGetListZaloAccounts = 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-accounts'
const canAddListZaloAccounts = 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-accounts'
const canUpdateListZaloAccounts = 'PUT::/api/otek-dashboard/zalo-account-service/update-list-zalo-accounts'
const canDeleteListZaloAccounts = 'DELETE::/api/otek-dashboard/zalo-account-service/delete-list-zalo-accounts'
const canGetListZaloAccountSessions = 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-sessions'
const canAddListZaloAccountSessions = 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-account-sessions'
const canUpdateListZaloAccountSessions = 'PUT::/api/otek-dashboard/zalo-account-service/update-list-zalo-account-sessions'
const canGetListZaloAccountUserPermissions = 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-user-permissions'
const canAddListZaloAccountUserPermissions = 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-account-user-permissions'
const canUpdateListZaloAccountUserPermissions = 'PUT::/api/otek-dashboard/zalo-account-service/update-list-zalo-account-user-permissions'
const canDeleteListZaloAccountUserPermissions = 'DELETE::/api/otek-dashboard/zalo-account-service/delete-list-zalo-account-user-permissions'
const canCheckSessionActive = 'GET::/api/otek-dashboard/zalo-account-service/check-session-active'
const canGetSessionCredentials = 'GET::/api/otek-dashboard/zalo-account-service/get-session-credentials'
const canLogVerifySession = 'POST::/api/otek-dashboard/zalo-account-service/log-verify-session'
const canCompleteZaloLogin = 'POST::/api/otek-dashboard/zalo-account-service/complete-zalo-login'
const canTransferPrimaryOwnership = 'POST::/api/otek-dashboard/zalo-account-service/transfer-primary-ownership'
const canSyncZaloAccountFriends = 'POST::/api/otek-dashboard/zalo-account-service/sync-zalo-account-friends'
const canGetListZaloAccountFriends = 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-friends'
const canGetListZaloAccountCompanies = 'GET::/api/otek-dashboard/zalo-account-service/get-list-zalo-account-companies'
const canAddListZaloAccountCompanies = 'POST::/api/otek-dashboard/zalo-account-service/add-list-zalo-account-companies'
const canDeleteListZaloAccountCompanies = 'DELETE::/api/otek-dashboard/zalo-account-service/delete-list-zalo-account-companies'
// Zalo Friend-Invite (Phase 2.1) — path params use `*` (Casbin keyMatch)
const canSendZaloFriendInvite = 'POST::/api/otek-dashboard/zalo-account-service/friend-invite'
const canGetCompanyZaloConfigStatus = 'GET::/api/otek-dashboard/zalo-account-service/cp-config/*/status'
const canCrossCheckFriendInvite = 'POST::/api/otek-dashboard/zalo-account-service/friend-invite/cross-check'
const canListPendingInvitationsByAccount = 'GET::/api/otek-dashboard/zalo-account-service/friend-invite/pending-by-account'
const canListFriendInvitations = 'GET::/api/otek-dashboard/zalo-account-service/friend-invite/list'
const canCheckFriendInviteStatus = 'GET::/api/otek-dashboard/zalo-account-service/friend-invite/check-status'
// Zalo CP-Config admin CRUD (Phase 2.1)
const canGetListCompanyZaloConfig = 'GET::/api/otek-dashboard/zalo-account-service/cp-config'
const canGetCompanyZaloConfig = 'GET::/api/otek-dashboard/zalo-account-service/cp-config/*'
const canAddCompanyZaloConfig = 'POST::/api/otek-dashboard/zalo-account-service/cp-config'
const canUpdateCompanyZaloConfig = 'PUT::/api/otek-dashboard/zalo-account-service/cp-config'
const canDeleteCompanyZaloConfig = 'DELETE::/api/otek-dashboard/zalo-account-service/cp-config/*'

// Outlet CRM (Plan 1-3) — resource strings must match Casbin base_permission
// entries. Endpoints with :id use `/*` so Casbin keyMatch matches the real
// path (e.g. /outlet/otl_abc) and FE listPermission comparison stays exact.
const canGetListOutlets = 'POST::/api/otek-dashboard/outlet/filter'
const canGetOutletById = 'GET::/api/otek-dashboard/outlet/*'
const canAddOutlet = 'POST::/api/otek-dashboard/outlet'
const canUpdateOutlet = 'PATCH::/api/otek-dashboard/outlet/*'
const canDeleteOutlet = 'DELETE::/api/otek-dashboard/outlet/*'

const canGetListOutletInventoryLinks = 'POST::/api/otek-dashboard/outlet-inventory-link/filter'
const canGetOutletInventoryLinkById = 'GET::/api/otek-dashboard/outlet-inventory-link/*'
const canAddOutletInventoryLink = 'POST::/api/otek-dashboard/outlet-inventory-link'
const canUpdateOutletInventoryLink = 'PATCH::/api/otek-dashboard/outlet-inventory-link/*'
const canDeleteOutletInventoryLink = 'DELETE::/api/otek-dashboard/outlet-inventory-link/*'

const canCreateOutletOrder = 'POST::/api/otek-dashboard/outlet-order/create'
const canLinkExistingOutletOrder = 'POST::/api/otek-dashboard/outlet-order/link-existing'

const canGetListOutletActivities = 'POST::/api/otek-dashboard/outlet-activity/filter'
const canGetOutletActivityById = 'GET::/api/otek-dashboard/outlet-activity/*'
const canAddOutletActivity = 'POST::/api/otek-dashboard/outlet-activity'
const canUpdateOutletActivity = 'PATCH::/api/otek-dashboard/outlet-activity/*'
const canDeleteOutletActivity = 'DELETE::/api/otek-dashboard/outlet-activity/*'
const canGetUpcomingOutletActivities = 'POST::/api/otek-dashboard/outlet-activity/upcoming'

const canGetListOutletPricings = 'POST::/api/otek-dashboard/outlet-pricing/filter'
const canGetOutletPricingById = 'GET::/api/otek-dashboard/outlet-pricing/*'
const canAddOutletPricing = 'POST::/api/otek-dashboard/outlet-pricing'
const canUpdateOutletPricing = 'PATCH::/api/otek-dashboard/outlet-pricing/*'
const canDeleteOutletPricing = 'DELETE::/api/otek-dashboard/outlet-pricing/*'
const canGetActiveOutletPricing = 'POST::/api/otek-dashboard/outlet-pricing/get-active'

// Outlet analytics (Plan 6)
const canGetOutletStats = 'POST::/api/otek-dashboard/outlet-analytics/stats'
const canGetOutletRegionReport = 'POST::/api/otek-dashboard/outlet-analytics/region-report'
const canGetOutletSaleEfficiency = 'POST::/api/otek-dashboard/outlet-analytics/sale-efficiency'
const canGetOutletOverdue = 'POST::/api/otek-dashboard/outlet-analytics/overdue'
const canGetOutletGeoOptions = 'POST::/api/otek-dashboard/outlet-analytics/geo-options'
const canGetOutletActivationHistory = 'POST::/api/otek-dashboard/outlet-analytics/activation-history'

export const setUserPermissions = (user: IUser) => {
    const userPermission = user.listPermission

    user.isAdmin = user.username === ADMIN_USERNAME
    if (user.isAdmin) {
        user.listPermission?.push(ADMIN_USERNAME)
    }
    user.canSeePackageTab = userPermission?.includes(canSeePackageTab)
    user.canUpdatePhoneSim = userPermission?.includes(canUpdatePhoneSim)
    user.canSelectDateConnect = userPermission?.includes(canSelectDateConnect)

    // Companies
    user.canGetListCompanies = userPermission?.includes(canGetListCompanies)
    user.canAddCompany = userPermission?.includes(canAddCompany)
    user.canAddListPackages = userPermission?.includes(canAddListPackages)
    user.canUpdateCompany = userPermission?.includes(canUpdateCompany)
    user.canDeleteCompany = userPermission?.includes(canDeleteCompany)
    user.canGetListMetadata = userPermission?.includes(canGetListMetadata)
    user.canAddListMetadata = userPermission?.includes(canAddListMetadata)
    user.canUpdateListMetadata = userPermission?.includes(canUpdateListMetadata)
    user.canGetListFeedbackHistory = userPermission?.includes(canGetListFeedbackHistory)
    user.canAddListFeedbackHistory = userPermission?.includes(canAddListFeedbackHistory)
    user.canUpdateListFeedbackHistory = userPermission?.includes(canUpdateListFeedbackHistory)
    user.canGetListCompanyNotifyConfig = userPermission?.includes(canGetListCompanyNotifyConfig)
    user.canGetCompanyNotifyConfig = userPermission?.includes(canGetCompanyNotifyConfig)
    user.canAddCompanyNotifyConfig = userPermission?.includes(canAddCompanyNotifyConfig)
    user.canUpdateCompanyNotifyConfig = userPermission?.includes(canUpdateCompanyNotifyConfig)
    user.canCompanyManagement = user.canGetListCompanies
        || user.canAddCompany
        || user.canUpdateCompany
        || user.canDeleteCompany
        || user.canGetListMetadata
        || user.canAddListMetadata
        || user.canUpdateListMetadata
        || user.canGetListFeedbackHistory
        || user.canAddListFeedbackHistory
        || user.canUpdateListFeedbackHistory
        || user.canGetListCompanyNotifyConfig
        || user.canGetCompanyNotifyConfig
        || user.canAddCompanyNotifyConfig
        || user.canUpdateCompanyNotifyConfig

    // Packages
    user.canGetListPackages = userPermission?.includes(canGetListPackages)
    user.canAddPackage = userPermission?.includes(canAddPackage)
    user.canAddListPackages = userPermission?.includes(canAddListPackages)
    user.canUpdatePackage = userPermission?.includes(canUpdatePackage)
    user.canDeletePackage = userPermission?.includes(canDeletePackage)
    user.canPackageManagement = user.canGetListPackages
        || user.canAddPackage
        || user.canAddListPackages
        || user.canUpdatePackage
        || user.canDeletePackage

    // Partner Packages
    user.canGetListPartnerPackages = userPermission?.includes(canGetListPartnerPackages)
    user.canAddPartnerPackage = userPermission?.includes(canAddPartnerPackage)
    user.canAddListPartnerPackages = userPermission?.includes(canAddListPartnerPackages)
    user.canDeletePartnerPackage = userPermission?.includes(canDeletePartnerPackage)
    user.canUpdatePartnerPackage = userPermission?.includes(canUpdatePartnerPackage)
    user.canGetListPackagesTkgDashboard = userPermission?.includes(canGetListPackagesTkgDashboard)
    user.canGetListPackagesSponsor = userPermission?.includes(canGetListPackagesSponsor)
    user.canGetListPackagesConnection = userPermission?.includes(canGetListPackagesConnection)
    user.canPartnerPackageManagement = user.canGetListPartnerPackages
        || user.canAddPartnerPackage
        || user.canAddListPartnerPackages
        || user.canDeletePartnerPackage
        || user.canUpdatePartnerPackage
        || user.canGetListPackagesTkgDashboard
        || user.canGetListPackagesSponsor
        || user.canGetListPackagesConnection

    // Rule base
    user.canGetListPackageDiscount = userPermission?.includes(canGetListPackageDiscount)
    user.canAddListPackageDiscount = userPermission?.includes(canAddListPackageDiscount)
    user.canUpdateListPackageDiscount = userPermission?.includes(canUpdateListPackageDiscount)
    user.canDeleteListPackageDiscount = userPermission?.includes(canDeleteListPackageDiscount)
    user.canGetListConditionRule = userPermission?.includes(canGetListConditionRule)
    user.canAddListConditionRule = userPermission?.includes(canAddListConditionRule)
    user.canUpdateListConditionRule = userPermission?.includes(canUpdateListConditionRule)
    user.canDeleteListConditionRule = userPermission?.includes(canDeleteListConditionRule)
    user.canRuleBaseManagement = user.canGetListPackageDiscount
        || user.canAddListPackageDiscount
        || user.canUpdateListPackageDiscount
        || user.canDeleteListPackageDiscount
        || user.canGetListConditionRule
        || user.canAddListConditionRule
        || user.canUpdateListConditionRule
        || user.canDeleteListConditionRule

    // Telegrams
    user.canGetListTelegrams = userPermission?.includes(canGetListTelegrams)
    user.canAddTelegram = userPermission?.includes(canAddTelegram)
    user.canUpdateTelegram = userPermission?.includes(canUpdateTelegram)
    user.canDeleteTelegram = userPermission?.includes(canDeleteTelegram)
    user.canTelegramManagement = user.canGetListTelegrams
        || user.canAddTelegram
        || user.canUpdateTelegram
        || user.canDeleteTelegram

    // Transactions
    user.canGetListTransactions = userPermission?.includes(canGetListTransactions)
    user.canRenewTransaction = userPermission?.includes(canRenewTransaction)
    user.canAddTransaction = userPermission?.includes(canAddTransaction)
    user.canConnectTransaction = userPermission?.includes(canConnectTransaction)
    user.canTransactionManagement = user.canGetListTransactions
        || user.canRenewTransaction
        || user.canAddTransaction
        || user.canConnectTransaction

    // Users
    user.canGetListUsers = userPermission?.includes(canGetListUsers)
    user.canAddUser = userPermission?.includes(canAddUser)
    user.canUpdateUser = userPermission?.includes(canUpdateUser)
    user.canDeleteUser = userPermission?.includes(canDeleteUser)
    user.canUserManagement = user.canGetListUsers
        || user.canAddUser
        || user.canUpdateUser
        || user.canDeleteUser

    // Roles
    user.canGetListBasePermissions = userPermission?.includes(canGetListBasePermissions)
    user.canReloadBasePermissions = userPermission?.includes(canReloadBasePermissions)
    user.canGetListRoles = userPermission?.includes(canGetListRoles)
    user.canAddRole = userPermission?.includes(canAddRole)
    user.canUpdateRole = userPermission?.includes(canUpdateRole)
    user.canDeleteRole = userPermission?.includes(canDeleteRole)
    user.canRoleManagement = user.canGetListBasePermissions
        || user.canReloadBasePermissions
        || user.canGetListRoles
        || user.canAddRole
        || user.canUpdateRole
        || user.canDeleteRole

    // Sim Passports
    user.canGetListSimPassports = userPermission?.includes(canGetListSimPassports)
    user.canUpdateSimPassport = userPermission?.includes(canUpdateSimPassport)
    user.canSimPassportManagement = user.canGetListSimPassports
        || user.canUpdateSimPassport

    //Topup
    user.canCheckBalanceTopup = userPermission?.includes(canCheckBalanceTopup)
    user.canGetListOrderTopups = userPermission?.includes(canGetListOrderTopups)
    user.canGetListTransactionTopupsByOrderId = userPermission?.includes(canGetListTransactionTopupsByOrderId)
    user.canCheckTransactionTopupOnResource = userPermission?.includes(canCheckTransactionTopupOnResource)
    user.canCheckTransactionTopupOnAdapter = userPermission?.includes(canCheckTransactionTopupOnAdapter)
    user.canUploadOrderTopupByExcel = userPermission?.includes(canUploadOrderTopupByExcel)
    user.canTopupByPhone = userPermission?.includes(canTopupByPhone)
    user.canTopupByOrderId = userPermission?.includes(canTopupByOrderId)
    user.canUpdateStatusTransactionTopup = userPermission?.includes(canUpdateStatusTransactionTopup)
    user.canUpdateLockOrderTopup = userPermission?.includes(canUpdateLockOrderTopup)
    user.canTopupManagement = user.canCheckBalanceTopup
        || user.canGetListOrderTopups
        || user.canGetListTransactionTopupsByOrderId
        || user.canCheckTransactionTopupOnResource
        || user.canCheckTransactionTopupOnAdapter
        || user.canUploadOrderTopupByExcel
        || user.canTopupByPhone
        || user.canTopupByOrderId
        || user.canUpdateStatusTransactionTopup
        || user.canUpdateLockOrderTopup

    // Report
    user.canCreateReportOrderTopups = userPermission?.includes(canCreateReportOrderTopups)
    user.canCreateReportTransactionConnection = userPermission?.includes(canCreateReportTransactionConnection)
    user.canCreateReportTransactionConnectionAll = userPermission?.includes(canCreateReportTransactionConnectionAll)
    user.canGetReportStatus = userPermission?.includes(canGetReportStatus)
    user.canGetReportDownload = userPermission?.includes(canGetReportDownload)
    user.canReportManagement = user.canCreateReportOrderTopups
        || user.canCreateReportTransactionConnection
        || user.canCreateReportTransactionConnectionAll
        || user.canGetReportStatus
        || user.canGetReportDownload

    //Tkg Dashboard
    user.canGetDynamicPartnerOffer = userPermission?.includes(canGetDynamicPartnerOffer)
    user.canGetListOrderTkgDashboard = userPermission?.includes(canGetListOrderTkgDashboard)
    user.canGetListTransactionTkgDashboardByOrderId = userPermission?.includes(canGetListTransactionTkgDashboardByOrderId)
    user.canCheckTransactionTkgOnResource = userPermission?.includes(canCheckTransactionTkgOnResource)
    user.canCheckTransactionTkgOnAdapter = userPermission?.includes(canCheckTransactionTkgOnAdapter)
    user.canUploadOrderTkgByExcel = userPermission?.includes(canUploadOrderTkgByExcel)
    user.canTkgByPhone = userPermission?.includes(canTkgByPhone)
    user.canTkgByOrderId = userPermission?.includes(canTkgByOrderId)
    user.canUpdateStatusTransactionTkgDashboard = userPermission?.includes(canUpdateStatusTransactionTkgDashboard)
    user.canUpdateLockOrderTkgDashboard = userPermission?.includes(canUpdateLockOrderTkgDashboard)
    user.canTkgDashboardManagement = user.canGetDynamicPartnerOffer
        || user.canGetListOrderTkgDashboard
        || user.canGetListTransactionTkgDashboardByOrderId
        || user.canCheckTransactionTkgOnResource
        || user.canCheckTransactionTkgOnAdapter
        || user.canUploadOrderTkgByExcel
        || user.canTkgByPhone
        || user.canTkgByOrderId
        || user.canUpdateLockOrderTkgDashboard
        || user.canUpdateStatusTransactionTkgDashboard

    //Data Sponsor
    user.canGetDynamicPartnerOfferDataSponsor = userPermission?.includes(canGetDynamicPartnerOfferDataSponsor)
    user.canGetListOrderDataSponsor = userPermission?.includes(canGetListOrderDataSponsor)
    user.canGetListTransactionDataSponsorByOrderId = userPermission?.includes(canGetListTransactionDataSponsorByOrderId)
    user.canCheckTransactionDataSponsorOnResource = userPermission?.includes(canCheckTransactionDataSponsorOnResource)
    user.canCheckTransactionDataSponsorOnAdapter = userPermission?.includes(canCheckTransactionDataSponsorOnAdapter)
    user.canUploadOrderDataSponsorByExcel = userPermission?.includes(canUploadOrderDataSponsorByExcel)
    user.canDataSponsorByPhone = userPermission?.includes(canDataSponsorByPhone)
    user.canDataSponsorByOrderId = userPermission?.includes(canDataSponsorByOrderId)
    user.canCheckWalletBalancePostpaid = userPermission?.includes(canCheckWalletBalancePostpaid)
    user.canUpdateStatusTransactionDataSponsor = userPermission?.includes(canUpdateStatusTransactionDataSponsor)
    user.canUpdateLockOrderDataSponsor = userPermission?.includes(canUpdateLockOrderDataSponsor)
    user.canDataSponsorManagement = user.canGetDynamicPartnerOffer
        || user.canGetListOrderDataSponsor
        || user.canGetListTransactionDataSponsorByOrderId
        || user.canCheckTransactionDataSponsorOnResource
        || user.canCheckTransactionDataSponsorOnAdapter
        || user.canUploadOrderDataSponsorByExcel
        || user.canDataSponsorByPhone
        || user.canDataSponsorByOrderId
        || user.canCheckWalletBalancePostpaid
        || user.canUpdateStatusTransactionDataSponsor
        || user.canUpdateLockOrderDataSponsor

    // User Partner
    user.canGetListUserPartners = userPermission?.includes(canGetListUserPartners)
    user.canAddUserPartner = userPermission?.includes(canAddUserPartner)
    user.canUpdateUserPartner = userPermission?.includes(canUpdateUserPartner)
    user.canDeleteUserPartner = userPermission?.includes(canDeleteUserPartner)
    user.canUserPartnerManagement = user.canGetListUserPartners
        || user.canAddUser
        || user.canUpdateUser
        || user.canDeleteUser

    // Transaction Connection
    user.canGetListTransactionConnection = userPermission?.includes(canGetListTransactionConnection)
    user.canAddListTransactionConnection = userPermission?.includes(canAddListTransactionConnection)
    user.canUpdateListTransactionConnection = userPermission?.includes(canUpdateListTransactionConnection)
    user.canAddTransactionConnectionBySyntax = userPermission?.includes(canAddTransactionConnectionBySyntax)
    user.canGetListTransactionConnectionExpire = userPermission?.includes(canGetListTransactionConnectionExpire)
    user.canGetListTransactionConnectionView = userPermission?.includes(canGetListTransactionConnectionView)
    user.canUpdateListSimTransactionConnection = userPermission?.includes(canUpdateListSimTransactionConnection)
    user.canUpdatePhoneNumberTransactionConnection = userPermission?.includes(canUpdatePhoneNumberTransactionConnection)
    user.canUpdateDataPackTransactionConnection = userPermission?.includes(canUpdateDataPackTransactionConnection)
    user.canUpdateFailedTransactionConnection = userPermission?.includes(canUpdateFailedTransactionConnection)
    user.canGetListRegistrationRequests = userPermission?.includes(canGetListRegistrationRequests)
    user.canAddListRegistrationRequests = userPermission?.includes(canAddListRegistrationRequests)
    user.canUpdateListRegistrationRequests = userPermission?.includes(canUpdateListRegistrationRequests)
    user.canDeleteListRegistrationRequests = userPermission?.includes(canDeleteListRegistrationRequests)
    user.canGetListOrderTransactionConnection = userPermission?.includes(canGetListOrderTransactionConnection)
    user.canGetOrderTransactionConnectionDetail = userPermission?.includes(canGetOrderTransactionConnectionDetail)
    user.canUploadOrderTransactionConnectionByExcel = userPermission?.includes(canUploadOrderTransactionConnectionByExcel)
    user.canAddTransactionConnectionByOrderId = userPermission?.includes(canAddTransactionConnectionByOrderId)
    user.canUpdateOrderTransactionConnection = userPermission?.includes(canUpdateOrderTransactionConnection)
    user.canTransactionConnectionManagement = user.canGetListTransactionConnection
        || user.canAddListTransactionConnection
        || user.canUpdateListTransactionConnection
        || user.canAddTransactionConnectionBySyntax
        || user.canGetListTransactionConnectionExpire
        || user.canGetListTransactionConnectionView
        || user.canUpdateListSimTransactionConnection
        || user.canUpdatePhoneNumberTransactionConnection
        || user.canUpdateDataPackTransactionConnection
        || user.canUpdateFailedTransactionConnection
        || user.canGetListRegistrationRequests
        || user.canAddListRegistrationRequests
        || user.canUpdateListRegistrationRequests
        || user.canDeleteListRegistrationRequests
        || user.canGetListOrderTransactionConnection
        || user.canGetOrderTransactionConnectionDetail
        || user.canUploadOrderTransactionConnectionByExcel
        || user.canAddTransactionConnectionByOrderId
        || user.canUpdateOrderTransactionConnection

    // Statistical Service
    user.canGetRevenueConnection = userPermission?.includes(canGetRevenueConnection)
    user.canGetRevenueDateConnection = userPermission?.includes(canGetRevenueDateConnection)
    user.canGetStatisticalTypeConnection = userPermission?.includes(canGetStatisticalTypeConnection)
    user.canGetStatisticalDateConnection = userPermission?.includes(canGetStatisticalDateConnection)
    user.canGetStatisticalPackDurationConnection = userPermission?.includes(canGetStatisticalPackDurationConnection)
    user.canGetStatisticalTypeExpiration = userPermission?.includes(canGetStatisticalTypeExpiration)
    user.canGetStatisticalDateExpiration = userPermission?.includes(canGetStatisticalDateExpiration)
    user.canGetStatisticalDateExtension = userPermission?.includes(canGetStatisticalDateExtension)
    user.canRecalculateStatistics = userPermission?.includes(canRecalculateStatistics)
    user.canGetStatisticalDateCalling = userPermission?.includes(canGetStatisticalDateCalling)
    user.canGetStatisticalTypeCalling = userPermission?.includes(canGetStatisticalTypeCalling)
    user.canGetStatisticalTelesaleCalling = userPermission?.includes(canGetStatisticalTelesaleCalling)
    user.canStatisticalServiceManagement = user.canGetRevenueConnection
        || user.canGetStatisticalTypeConnection
        || user.canGetStatisticalDateConnection
        || user.canGetStatisticalPackDurationConnection
        || user.canGetStatisticalTypeExpiration
        || user.canGetStatisticalDateExpiration
        || user.canGetStatisticalDateExtension
        || user.canRecalculateStatistics
        || user.canGetStatisticalDateCalling
        || user.canGetStatisticalTypeCalling
        || user.canGetStatisticalTelesaleCalling

    // Customer Resource
    user.canGetListCustomerResource = userPermission?.includes(canGetListCustomerResource)
    user.canAddListCustomerResource = userPermission?.includes(canAddListCustomerResource)
    user.canUpdateListCustomerResource = userPermission?.includes(canUpdateListCustomerResource)
    user.canCustomerResourceManagement = user.canGetListCustomerResource
        || user.canAddListCustomerResource
        || user.canUpdateListCustomerResource

    // Phone Agency
    user.canGetListPhoneAgencies = userPermission?.includes(canGetListPhoneAgencies)
    user.canAddListPhoneAgencies = userPermission?.includes(canAddListPhoneAgencies)
    user.canUpdateListPhoneAgencies = userPermission?.includes(canUpdateListPhoneAgencies)
    user.canPhoneAgenciesManagement = user.canGetListPhoneAgencies
        || user.canAddListPhoneAgencies
        || user.canUpdateListPhoneAgencies

    // Call Info
    user.canGetListCallInfo = userPermission?.includes(canGetListCallInfo)
    user.canGetListCallInfoDetail = userPermission?.includes(canGetListCallInfoDetail)
    user.canAddListCallTelesale = userPermission?.includes(canAddListCallTelesale)
    user.canAddLogFeedback = userPermission?.includes(canAddLogFeedback)
    user.canUpdateListCallInfo = userPermission?.includes(canUpdateListCallInfo)
    user.canCallInfoManagement = user.canGetListCallInfo
        || user.canGetListCallInfoDetail
        || user.canAddListCallTelesale
        || user.canAddLogFeedback
        || user.canUpdateListCallInfo

    // Call Log
    user.canGetListCallLog = userPermission?.includes(canGetListCallLog)
    user.canAddListCallLog = userPermission?.includes(canAddListCallLog)
    user.canUpdateListCallLog = userPermission?.includes(canUpdateListCallLog)
    user.canCallLogManagement = user.canGetListCallLog
        || user.canAddListCallLog
        || user.canUpdateListCallLog

    // Mbh Inventory
    user.canAddOrderInventory = userPermission?.includes(canAddOrderInventory)
    user.canGetListOrderInventory = userPermission?.includes(canGetListOrderInventory)
    user.canUpdateOrderInventory = userPermission?.includes(canUpdateOrderInventory)
    user.canGetListSimInventory = userPermission?.includes(canGetListSimInventory)
    user.canGetSimInventoryByOrderIds = userPermission?.includes(canGetSimInventoryByOrderIds)
    user.canUpdateSimInventory = userPermission?.includes(canUpdateSimInventory)
    user.canAddOrderWarehouse = userPermission?.includes(canAddOrderWarehouse)
    user.canGetListOrderWarehouse = userPermission?.includes(canGetListOrderWarehouse)
    user.canUpdateOrderWarehouse = userPermission?.includes(canUpdateOrderWarehouse)
    user.canViewExportOrderPage = userPermission?.includes(canViewExportOrderPage)
    user.canInventoryManagement = user.canAddOrderInventory
        || user.canGetListOrderInventory
        || user.canUpdateOrderInventory
        || user.canGetListSimInventory
        || user.canGetSimInventoryByOrderIds
        || user.canUpdateSimInventory
        || user.canAddOrderWarehouse
        || user.canGetListOrderWarehouse
        || user.canUpdateOrderWarehouse

    // Mbh Sales Inventory
    user.canAddSalesOrderInventory = userPermission?.includes(canAddSalesOrderInventory)
    user.canAddSalesOrderInfo = userPermission?.includes(canAddSalesOrderInfo)
    user.canGetListSalesOrderInventory = userPermission?.includes(canGetListSalesOrderInventory)
    user.canUpdateSalesOrderInventory = userPermission?.includes(canUpdateSalesOrderInventory)
    user.canViewSalesExportOrderPage = userPermission?.includes(canViewSalesExportOrderPage)
    user.canSalesInventoryManagement = user.canAddSalesOrderInventory
        || user.canAddSalesOrderInfo
        || user.canGetListSalesOrderInventory
        || user.canUpdateSalesOrderInventory
        || user.canViewSalesExportOrderPage

    // Config
    user.canGetListVersions = userPermission?.includes(canGetListVersions)
    user.canAddListVersions = userPermission?.includes(canAddListVersions)
    user.canUpdateListVersions = userPermission?.includes(canUpdateListVersions)
    user.canDeleteListVersions = userPermission?.includes(canDeleteListVersions)
    user.canGetListBankAccounts = userPermission?.includes(canGetListBankAccounts)
    user.canAddListBankAccounts = userPermission?.includes(canAddListBankAccounts)
    user.canUpdateListBankAccounts = userPermission?.includes(canUpdateListBankAccounts)
    user.canGetListPartnerConfig = userPermission?.includes(canGetListPartnerConfig)
    user.canAddListPartnerConfig = userPermission?.includes(canAddListPartnerConfig)
    user.canUpdateListPartnerConfig = userPermission?.includes(canUpdateListPartnerConfig)
    user.canGetListTopUpConfig = userPermission?.includes(canGetListTopUpConfig)
    user.canAddListTopUpConfig = userPermission?.includes(canAddListTopUpConfig)
    user.canUpdateListTopUpConfig = userPermission?.includes(canUpdateListTopUpConfig)
    user.canGetListTkgConfig = userPermission?.includes(canGetListTkgConfig)
    user.canAddListTkgConfig = userPermission?.includes(canAddListTkgConfig)
    user.canUpdateListTkgConfig = userPermission?.includes(canUpdateListTkgConfig)
    user.canGetListDevices = userPermission?.includes(canGetListDevices)
    user.canAddListDevices = userPermission?.includes(canAddListDevices)
    user.canUpdateListDevices = userPermission?.includes(canUpdateListDevices)
    user.canDeleteListDevices = userPermission?.includes(canDeleteListDevices)
    user.canGetListTelesaleConfig = userPermission?.includes(canGetListTelesaleConfig)
    user.canAddListTelesaleConfig = userPermission?.includes(canAddListTelesaleConfig)
    user.canUpdateListTelesaleConfig = userPermission?.includes(canUpdateListTelesaleConfig)
    user.canGetListInvoiceConfig = userPermission?.includes(canGetListInvoiceConfig)
    user.canAddListInvoiceConfig = userPermission?.includes(canAddListInvoiceConfig)
    user.canUpdateListInvoiceConfig = userPermission?.includes(canUpdateListInvoiceConfig)
    user.canGetListSannConfig = userPermission?.includes(canGetListSannConfig)
    user.canAddListSannConfig = userPermission?.includes(canAddListSannConfig)
    user.canUpdateListSannConfig = userPermission?.includes(canUpdateListSannConfig)
    user.canConfigManagement = user.canGetListVersions
        || user.canAddListVersions
        || user.canUpdateListVersions
        || user.canDeleteListVersions
        || user.canGetListBankAccounts
        || user.canAddListBankAccounts
        || user.canUpdateListBankAccounts
        || user.canGetListPartnerConfig
        || user.canAddListPartnerConfig
        || user.canUpdateListPartnerConfig
        || user.canGetListTopUpConfig
        || user.canAddListTopUpConfig
        || user.canUpdateListTopUpConfig
        || user.canGetListTkgConfig
        || user.canAddListTkgConfig
        || user.canUpdateListTkgConfig
        || user.canGetListDevices
        || user.canAddListDevices
        || user.canUpdateListDevices
        || user.canDeleteListDevices
        || user.canGetListTelesaleConfig
        || user.canAddListTelesaleConfig
        || user.canUpdateListTelesaleConfig
        || user.canGetListInvoiceConfig
        || user.canAddListInvoiceConfig
        || user.canUpdateListInvoiceConfig
        || user.canGetListSannConfig
        || user.canAddListSannConfig
        || user.canUpdateListSannConfig


    // Invoice
    user.canGetTypeInvoiceAdapter = userPermission?.includes(canGetTypeInvoiceAdapter)
    user.canGetInvoiceAdapter = userPermission?.includes(canGetInvoiceAdapter)
    user.canGetListInvoiceAdapter = userPermission?.includes(canGetListInvoiceAdapter)
    user.canGetPrintInvoiceAdapter = userPermission?.includes(canGetPrintInvoiceAdapter)
    user.canGetListInvoices = userPermission?.includes(canGetListInvoices)
    user.canAddInvoice = userPermission?.includes(canAddInvoice)
    user.canAddInvoiceByForm = userPermission?.includes(canAddInvoiceByForm)
    user.canUpdateInvoice = userPermission?.includes(canUpdateInvoice)
    user.canDeleteInvoice = userPermission?.includes(canDeleteInvoice)
    user.canGetListInvoiceTemplates = userPermission?.includes(canGetListInvoiceTemplates)
    user.canAddListInvoiceTemplates = userPermission?.includes(canAddListInvoiceTemplates)
    user.canUpdateListInvoiceTemplates = userPermission?.includes(canUpdateListInvoiceTemplates)
    user.canDeleteListInvoiceTemplates = userPermission?.includes(canDeleteListInvoiceTemplates)
    user.canGetListInvoiceTemplateItems = userPermission?.includes(canGetListInvoiceTemplateItems)
    user.canAddListInvoiceTemplateItems = userPermission?.includes(canAddListInvoiceTemplateItems)
    user.canUpdateListInvoiceTemplateItems = userPermission?.includes(canUpdateListInvoiceTemplateItems)
    user.canDeleteListInvoiceTemplateItems = userPermission?.includes(canDeleteListInvoiceTemplateItems)
    user.canAddInvoiceAdapterByInvoiceId = userPermission?.includes(canAddInvoiceAdapterByInvoiceId)
    user.canInvoiceManagement = user.canGetTypeInvoiceAdapter
        || user.canGetInvoiceAdapter
        || user.canGetListInvoiceAdapter
        || user.canGetPrintInvoiceAdapter
        || user.canGetListInvoices
        || user.canAddInvoice
        || user.canAddInvoiceByForm
        || user.canUpdateInvoice
        || user.canDeleteInvoice
        || user.canGetListInvoiceTemplates
        || user.canAddListInvoiceTemplates
        || user.canUpdateListInvoiceTemplates
        || user.canDeleteListInvoiceTemplates
        || user.canGetListInvoiceTemplateItems
        || user.canAddListInvoiceTemplateItems
        || user.canUpdateListInvoiceTemplateItems
        || user.canDeleteListInvoiceTemplateItems
        || user.canAddInvoiceAdapterByInvoiceId

    // Zalo Account
    user.canGetListZaloAccounts = userPermission?.includes(canGetListZaloAccounts)
    user.canAddListZaloAccounts = userPermission?.includes(canAddListZaloAccounts)
    user.canUpdateListZaloAccounts = userPermission?.includes(canUpdateListZaloAccounts)
    user.canDeleteListZaloAccounts = userPermission?.includes(canDeleteListZaloAccounts)
    user.canGetListZaloAccountSessions = userPermission?.includes(canGetListZaloAccountSessions)
    user.canAddListZaloAccountSessions = userPermission?.includes(canAddListZaloAccountSessions)
    user.canUpdateListZaloAccountSessions = userPermission?.includes(canUpdateListZaloAccountSessions)
    user.canGetListZaloAccountUserPermissions = userPermission?.includes(canGetListZaloAccountUserPermissions)
    user.canAddListZaloAccountUserPermissions = userPermission?.includes(canAddListZaloAccountUserPermissions)
    user.canUpdateListZaloAccountUserPermissions = userPermission?.includes(canUpdateListZaloAccountUserPermissions)
    user.canDeleteListZaloAccountUserPermissions = userPermission?.includes(canDeleteListZaloAccountUserPermissions)
    user.canCheckSessionActive = userPermission?.includes(canCheckSessionActive)
    user.canGetSessionCredentials = userPermission?.includes(canGetSessionCredentials)
    user.canLogVerifySession = userPermission?.includes(canLogVerifySession)
    user.canCompleteZaloLogin = userPermission?.includes(canCompleteZaloLogin)
    user.canTransferPrimaryOwnership = userPermission?.includes(canTransferPrimaryOwnership)
    user.canSyncZaloAccountFriends = userPermission?.includes(canSyncZaloAccountFriends)
    user.canGetListZaloAccountFriends = userPermission?.includes(canGetListZaloAccountFriends)
    user.canGetListZaloAccountCompanies = userPermission?.includes(canGetListZaloAccountCompanies)
    user.canAddListZaloAccountCompanies = userPermission?.includes(canAddListZaloAccountCompanies)
    user.canDeleteListZaloAccountCompanies = userPermission?.includes(canDeleteListZaloAccountCompanies)
    // Phase 2.1 — friend-invite
    user.canSendZaloFriendInvite = userPermission?.includes(canSendZaloFriendInvite)
    user.canGetCompanyZaloConfigStatus = userPermission?.includes(canGetCompanyZaloConfigStatus)
    user.canCrossCheckFriendInvite = userPermission?.includes(canCrossCheckFriendInvite)
    user.canListPendingInvitationsByAccount = userPermission?.includes(canListPendingInvitationsByAccount)
    user.canListFriendInvitations = userPermission?.includes(canListFriendInvitations)
    user.canCheckFriendInviteStatus = userPermission?.includes(canCheckFriendInviteStatus)
    // Phase 2.1 — CP-config admin CRUD
    user.canGetListCompanyZaloConfig = userPermission?.includes(canGetListCompanyZaloConfig)
    user.canGetCompanyZaloConfig = userPermission?.includes(canGetCompanyZaloConfig)
    user.canAddCompanyZaloConfig = userPermission?.includes(canAddCompanyZaloConfig)
    user.canUpdateCompanyZaloConfig = userPermission?.includes(canUpdateCompanyZaloConfig)
    user.canDeleteCompanyZaloConfig = userPermission?.includes(canDeleteCompanyZaloConfig)
    user.canZaloAccountManagement = user.canGetListZaloAccounts
        || user.canAddListZaloAccounts
        || user.canUpdateListZaloAccounts
        || user.canDeleteListZaloAccounts
        || user.canGetListZaloAccountSessions
        || user.canAddListZaloAccountSessions
        || user.canUpdateListZaloAccountSessions
        || user.canGetListZaloAccountUserPermissions
        || user.canAddListZaloAccountUserPermissions
        || user.canUpdateListZaloAccountUserPermissions
        || user.canDeleteListZaloAccountUserPermissions
        || user.canSendZaloFriendInvite
        || user.canGetCompanyZaloConfigStatus
        || user.canCrossCheckFriendInvite
        || user.canListPendingInvitationsByAccount
        || user.canListFriendInvitations
        || user.canGetListCompanyZaloConfig
        || user.canGetCompanyZaloConfig
        || user.canAddCompanyZaloConfig
        || user.canUpdateCompanyZaloConfig
        || user.canDeleteCompanyZaloConfig
}

const hasAnyAuthority = (functions: string[], hasAnyFunctions: string[]) => {
    if (_.isEmpty(functions)) {
        return false;
    }
    if (hasAnyFunctions.length === 0) {
        return true;
    }
    return hasAnyFunctions.some(auth => functions.includes(auth));
};

const PermUtils = {
    isAdmin,
    canSeePackageTab,
    canUpdatePhoneSim,
    canSelectDateConnect,

    // Companies
    canGetListCompanies,
    canAddCompany,
    canUpdateCompany,
    canDeleteCompany,
    canGetListCompanyNotifyConfig,
    canGetCompanyNotifyConfig,
    canAddCompanyNotifyConfig,
    canUpdateCompanyNotifyConfig,

    // Packages
    canGetListPackages,
    canAddPackage,
    canAddListPackages,
    canUpdatePackage,
    canDeletePackage,

    // Partner Packages
    canGetListPartnerPackages,
    canAddPartnerPackage,
    canAddListPartnerPackages,
    canDeletePartnerPackage,
    canUpdatePartnerPackage,
    canGetListPackagesTkgDashboard,
    canGetListPackagesSponsor,
    canGetListPackagesConnection,

    // Rule base
    canGetListPackageDiscount,
    canAddListPackageDiscount,
    canUpdateListPackageDiscount,
    canDeleteListPackageDiscount,
    canGetListConditionRule,
    canAddListConditionRule,
    canUpdateListConditionRule,
    canDeleteListConditionRule,

    // Telegrams
    canGetListTelegrams,
    canAddTelegram,
    canUpdateTelegram,
    canDeleteTelegram,

    // Transactions
    canGetListTransactions,
    canRenewTransaction,
    canAddTransaction,
    canConnectTransaction,

    // Users
    canGetListUsers,
    canAddUser,
    canUpdateUser,
    canDeleteUser,

    // Roles
    canGetListBasePermissions,
    canReloadBasePermissions,
    canGetListRoles,
    canAddRole,
    canUpdateRole,
    canDeleteRole,

    // Sim Passports
    canGetListSimPassports,
    canUpdateSimPassport,

    // Mbh Topups
    canCheckBalanceTopup,
    canGetListOrderTopups,
    canGetListTransactionTopupsByOrderId,
    canCheckTransactionTopupOnResource,
    canCheckTransactionTopupOnAdapter,
    canUploadOrderTopupByExcel,
    canTopupByPhone,
    canTopupByOrderId,
    canUpdateStatusTransactionTopup,

    // Report
    canCreateReportOrderTopups,
    canCreateReportTransactionConnection,
    canCreateReportTransactionConnectionAll,
    canGetReportStatus,
    canGetReportDownload,

    // Mbh Tkg Dashboard
    canGetDynamicPartnerOffer,
    canGetListOrderTkgDashboard,
    canGetListTransactionTkgDashboardByOrderId,
    canCheckTransactionTkgOnResource,
    canCheckTransactionTkgOnAdapter,
    canUploadOrderTkgByExcel,
    canTkgByPhone,
    canTkgByOrderId,
    canUpdateStatusTransactionTkgDashboard,

    // Data Sponsor
    canGetDynamicPartnerOfferDataSponsor,
    canGetListOrderDataSponsor,
    canGetListTransactionDataSponsorByOrderId,
    canCheckTransactionDataSponsorOnResource,
    canCheckTransactionDataSponsorOnAdapter,
    canUploadOrderDataSponsorByExcel,
    canDataSponsorByPhone,
    canDataSponsorByOrderId,
    canCheckWalletBalancePostpaid,
    canUpdateStatusTransactionDataSponsor,

    // User Partner
    canGetListUserPartners,
    canAddUserPartner,
    canUpdateUserPartner,
    canDeleteUserPartner,

    // Transaction Connection
    canGetListTransactionConnection,
    canAddListTransactionConnection,
    canUpdateListTransactionConnection,
    canAddTransactionConnectionBySyntax,
    canGetListTransactionConnectionExpire,
    canGetListTransactionConnectionView,
    canUpdateListSimTransactionConnection,
    canUpdatePhoneNumberTransactionConnection,
    canUpdateDataPackTransactionConnection,
    canUpdateFailedTransactionConnection,

    // Registration Request
    canGetListRegistrationRequests,
    canAddListRegistrationRequests,
    canUpdateListRegistrationRequests,
    canDeleteListRegistrationRequests,

    // Order Transaction Connection
    canGetListOrderTransactionConnection,
    canGetOrderTransactionConnectionDetail,
    canUploadOrderTransactionConnectionByExcel,
    canAddTransactionConnectionByOrderId,
    canUpdateOrderTransactionConnection,

    // Statistical Service
    canGetRevenueConnection,
    canGetRevenueDateConnection,
    canGetStatisticalTypeConnection,
    canGetStatisticalDateConnection,
    canGetStatisticalPackDurationConnection,
    canGetStatisticalTypeExpiration,
    canGetStatisticalDateExpiration,
    canGetStatisticalDateExtension,
    canRecalculateStatistics,
    canGetStatisticalDateCalling,
    canGetStatisticalTypeCalling,
    canGetStatisticalTelesaleCalling,

    // Customer Resource
    canGetListCustomerResource,
    canAddListCustomerResource,
    canUpdateListCustomerResource,

    // Phone Agency
    canGetListPhoneAgencies,
    canAddListPhoneAgencies,
    canUpdateListPhoneAgencies,

    // Call Info
    canGetListCallInfo,
    canGetListCallInfoDetail,
    canAddListCallTelesale,
    canAddLogFeedback,
    canUpdateListCallInfo,

    // Call Log
    canGetListCallLog,
    canAddListCallLog,
    canUpdateListCallLog,

    // Mbh Inventory
    canAddOrderInventory,
    canGetListOrderInventory,
    canUpdateOrderInventory,
    canGetListSimInventory,
    canGetSimInventoryByOrderIds,
    canUpdateSimInventory,
    canAddOrderWarehouse,
    canGetListOrderWarehouse,
    canUpdateOrderWarehouse,
    canViewExportOrderPage,

    // Mbh Sales Inventory
    canAddSalesOrderInventory,
    canAddSalesOrderInfo,
    canGetListSalesOrderInventory,
    canUpdateSalesOrderInventory,
    canViewSalesExportOrderPage,

    // Config
    canGetListVersions,
    canAddListVersions,
    canUpdateListVersions,
    canDeleteListVersions,
    canGetListBankAccounts,
    canAddListBankAccounts,
    canUpdateListBankAccounts,
    canGetListPartnerConfig,
    canAddListPartnerConfig,
    canUpdateListPartnerConfig,
    canGetListTopUpConfig,
    canAddListTopUpConfig,
    canUpdateListTopUpConfig,
    canGetListTkgConfig,
    canAddListTkgConfig,
    canUpdateListTkgConfig,
    canGetListDevices,
    canAddListDevices,
    canUpdateListDevices,
    canDeleteListDevices,
    canGetListTelesaleConfig,
    canAddListTelesaleConfig,
    canUpdateListTelesaleConfig,
    canGetListInvoiceConfig,
    canAddListInvoiceConfig,
    canUpdateListInvoiceConfig,

    // Invoice
    canGetTypeInvoiceAdapter,
    canGetInvoiceAdapter,
    canGetListInvoiceAdapter,
    canGetPrintInvoiceAdapter,
    canGetListInvoices,
    canAddInvoice,
    canAddInvoiceByForm,
    canUpdateInvoice,
    canDeleteInvoice,
    canGetListInvoiceTemplates,
    canAddListInvoiceTemplates,
    canUpdateListInvoiceTemplates,
    canDeleteListInvoiceTemplates,
    canGetListInvoiceTemplateItems,
    canAddListInvoiceTemplateItems,
    canUpdateListInvoiceTemplateItems,
    canDeleteListInvoiceTemplateItems,
    canAddInvoiceAdapterByInvoiceId,

    // Zalo Account
    canGetListZaloAccounts,
    canAddListZaloAccounts,
    canUpdateListZaloAccounts,
    canDeleteListZaloAccounts,
    canGetListZaloAccountSessions,
    canAddListZaloAccountSessions,
    canUpdateListZaloAccountSessions,
    canGetListZaloAccountUserPermissions,
    canAddListZaloAccountUserPermissions,
    canUpdateListZaloAccountUserPermissions,
    canDeleteListZaloAccountUserPermissions,
    canCheckSessionActive,
    canGetSessionCredentials,
    canLogVerifySession,
    canCompleteZaloLogin,
    canTransferPrimaryOwnership,
    canSyncZaloAccountFriends,
    canGetListZaloAccountFriends,
    canGetListZaloAccountCompanies,
    canAddListZaloAccountCompanies,
    canDeleteListZaloAccountCompanies,

    // Outlet CRM
    canGetListOutlets,
    canGetOutletById,
    canAddOutlet,
    canUpdateOutlet,
    canDeleteOutlet,
    canGetListOutletInventoryLinks,
    canGetOutletInventoryLinkById,
    canAddOutletInventoryLink,
    canUpdateOutletInventoryLink,
    canDeleteOutletInventoryLink,
    canCreateOutletOrder,
    canLinkExistingOutletOrder,
    canGetListOutletActivities,
    canGetOutletActivityById,
    canAddOutletActivity,
    canUpdateOutletActivity,
    canDeleteOutletActivity,
    canGetUpcomingOutletActivities,
    canGetListOutletPricings,
    canGetOutletPricingById,
    canAddOutletPricing,
    canUpdateOutletPricing,
    canDeleteOutletPricing,
    canGetActiveOutletPricing,
    canGetOutletStats,
    canGetOutletRegionReport,
    canGetOutletSaleEfficiency,
    canGetOutletOverdue,
    canGetOutletGeoOptions,
    canGetOutletActivationHistory,

    setUserPermissions,
    hasAnyAuthority,
}

export default PermUtils